import { TMECHANIC_LOGIN_ACTIVITY, TRESPONSE_MECHANIC_DASHBOARD } from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TMechanicDashboardActionType } from './mechanic-status-dashboard.models';

export class GetMechanicDashboardInfo implements Action {
  readonly type = TMechanicDashboardActionType.GetMechanicDashboardInfo;
}

export class GetMechanicDashboardInfoSuccess implements Action {
  readonly type = TMechanicDashboardActionType.GetMechanicDashboardInfoSuccess;
  constructor(public mechanicDashboardInfo: TMECHANIC_LOGIN_ACTIVITY[]) {}
}

export class GetMechanicDashboardInfoFailure implements Action {
  readonly type = TMechanicDashboardActionType.GetMechanicDashboardInfoFailure;
}

export type TMechanicDashboardActions =
  | GetMechanicDashboardInfo
  | GetMechanicDashboardInfoSuccess
  | GetMechanicDashboardInfoFailure;
